const initialState = {
  processingFeeData: "",
  isFetching: false,
  isError: "",
};

const processingFeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PROCESSING_FEE_STARTED":
      return {
        ...state,
        processingFeeData: "",
        isFetching: true,
        isError: "",
      };
    case "GET_PROCESSING_FEE_SUCCESS":
      return {
        ...state,
        processingFeeData: action.data,
        isFetching: false,
        isError: "",
      };
    case "GET_PROCESSING_FEE_FAILURE":
      return {
        ...state,
        isFetching: false,
        isError: action.error,
      };
    case "UPDATE_PROCESSING_FEE_STARTED":
      return {
        ...state,
        isFetching: true,
        isError: "",
      };
    case "UPDATE_PROCESSING_FEE_SUCCESS":
      return {
        ...state,
        isFetching: false,
        isError: "",
      };
    case "UPDATE_PROCESSING_FEE_FAILURE":
      return {
        ...state,
        isFetching: false,
        isError: action.error,
      };
    default:
      return state;
  }
};

export default processingFeeReducer;
